/** Sentinel id for the always-present agent entry in the Accounts page. */
export const AGENT_ACCOUNT_ID = '__agent__';
